<template>
  <div class="background-wrapper">
    <div v-if="Object.keys(groupNavList).length">
      <div class="group-tabs">
        <div class="group-tab" v-for="item in showGroupNavList(0, 1)" :key="item.team_id" @click="groupNavListId(item)">
          <!-- :class="{ 'group-tab-focus': Number(groupListDefault) === Number(item.team_id) }" -->
          <span class="group-tab-focus">{{groupListName}}</span>
        </div>
        <!-- 点击展开 -->
        <gkDropdown
          v-if="Object.keys(groupNavList).length > 0"
          class="dropdown all-group-text"
          :offset="8"
          :visible="showVisible"
        >
          <div @click.stop="handleTextFocus" class="group-expand">
            切换小组
            <i class="iconfont group-expand-icon">&#xe604;</i>
          </div>

          <div slot="popup">
            <div class="dropdown-options">
              <div
                class="all-group-list"
                :class="{ 'all-group-list-select': Number(groupListDefault) === Number(item.team_id) }"
                @click="groupNavListId(item, true)"
                v-for="item in groupNavList"
                :key="item.team_id"
              >
                <i :class="{ 'all-group-name-icon': Number(groupListDefault) === Number(item.team_id) }"></i>
                <span class="all-group-name" :class="{ 'all-group-name-select': Number(groupListDefault) === Number(item.team_id) }">{{item.team_name}}</span>
              </div>
            </div>
          </div>

        </gkDropdown>
      </div>

      <div>
        <!-- 小组成员 -->
        <div class="group-member-wrapper">
          <p class="group-member-text">小组成员</p>
            <GroupMember
              v-if="groupMemberList.length"
              :memberList="groupMemberList"
              :sliceQuantity="8"
            />
        </div>
        <div class="group-member-line"></div>
        <!-- 小组活动 -->
        <p class="group-activity-text">小组活动</p>
        <div v-if="Object.keys(groupActivityList).length">
          <div class="group-scroll columns is-multiline">
            <ActivityList
              v-for="event in groupActivityList"
              class="is-half"
              :key="event.id"
              :event="event"
              :branches="branches"
              :pageInfo="params"
              :eventStatusKey="'events_status'"
            />
          </div>
        </div>
        <div class="warnTip" v-else>
          <div class="warnTip-center">
            <img class="warnTip-center-img" src="../assets/img/sad.png" />
            <div class="warnTip-center-word">暂无信息</div>
          </div>
        </div>

        <MoreButton
          :loading="loading"
          :end="isEnd"
          :loadingCount="loadingCount"
          @click="getMore"
        />
      </div>
    </div>
    <div class="warnTip" v-else>
      <div class="warnTip-center">
        <img class="warnTip-center-img" src="../assets/img/sad.png" />
        <div class="warnTip-center-word">{{ isVIP ? '暂无信息' : '您还未成为TGO学员，暂无小组信息' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import service from '@/service'
import { getBranchAll } from '@/util/methods'

// import gkLoading from 'gkui/loading'
import gkDropdown from 'gkui/dropdown/Dropdown.vue'

import GroupMember from '@/components/list/MemberList'
import ActivityList from '@/components/list/ActivityList'
import MoreButton from '@/components/button/MoreButton.vue'
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
    GroupMember,
    ActivityList,
    // gkLoading,
    gkDropdown,
    MoreButton
  },
  data () {
    return {
      groupListDefault: 0,
      // tab栏数据
      groupNavList: [],
      // 小组成员信息
      groupMemberList: [],
      // 小组活动信息
      groupActivityList: [],
      // 分页数据
      params: {
        team_id: 0,
        page: 1,
        size: 8
      },
      // 页码
      page: {
        pages: 0,
        total: 0
      },
      // 正在加载
      loading: false,
      // 小组活动名称
      groupListName: '',
      // 数据加载完显示没有可加载数据
      showData: false,
      // 手动控制气泡显示隐藏
      showVisible: false,
      // 数据是否是最后
      isEnd: false,
      // 加载的次数
      loadingCount: 0,
      branches: []
    }
  },
  computed: {
    ...mapState(['isBottom']),
    ...mapGetters([
      'isVIP'
    ]),
    sectionGroupNavList (first, last) {
      const showGroupNavList = this.groupNavList.slice(first, last)
      return showGroupNavList
    }
  },

  created () {
    // tags
    Promise.all([getBranchAll(), service.getEventTypes()])
      .then(v => {
        v[0].unshift({ id: 99999, name: '总部' })
        this.branches = v[0]
        console.log('branches', v[0])
        this.tags.push({
          type_name: '主办方',
          type_key: 'branch_id',
          tags: v[0]
        })
        this.tags.push({
          type_name: '活动类型',
          type_key: 'event_type',
          tags: v[1]
        })
        this.tags.forEach(item => {
          item.tags.unshift({ id: '', name: '全部' })
        })
      })
      .catch(err => {
        console.log(err)
      })
  },

  mounted () {
    this.getGroupList()
    // 监听外部点击
    document.addEventListener('click', (e) => {
      if (e.target.className !== 'group-expand') {
        this.showVisible = false
      }
    })
  },

  methods: {
    // 获取小组列表
    getGroupList () {
      service.getGroupList()
        .then(res => {
          if (res) {
            this.groupNavList = res

            // 首次加载获取小组列表第一个数据
            if (this.groupListDefault === 0) {
              this.groupListDefault = res[0].team_id
              this.params.team_id = Number(res[0].team_id)
              this.groupListName = res[0].team_name
            }
            this.getGroupInfo(this.groupListDefault, this.params)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    // 点击tab栏
    groupNavListId (item, isAppend = false) {
      this.groupListDefault = item.team_id
      // 小组活动 team_id
      this.params.team_id = Number(item.team_id)
      // 点击之后获取
      this.params.page = 1
      // 重置加载次数
      this.loadingCount = 0
      // 每次点击重置 isEnd
      this.isEnd = false
      // // 每次点击tab栏取消右侧全部小组
      this.getGroupInfo(this.groupListDefault, this.params)

      if (isAppend) {
        // 点击更换全部小组名称
        this.groupListName = item.team_name
      }
    },

    // 小组成员信息和小组活动
    getGroupInfo (id, params) {
      // 小组成员信息
      service.getGroupInfo({ id: Number(id) })
        .then(res => {
          if (res.list) {
            this.groupMemberList = []
            this.groupMemberList = res.list
          }
        })
        .catch(err => {
          console.log(err)
        })

      // 小组活动
      this.getGroupActivity(params)
    },

    // 小组活动
    getGroupActivity (params, isAppend = false) {
      // 如果是最后一页 或者 正在加载 return 出去
      if (this.isEnd || this.loading) return

      // 获取小组活动
      return service.getGroupActivity(params)
        .then(res => {
          console.log('resRes', res)
          if (res) {
            this.page = res.page
            this.loadingCount++
            this.loading = false
            // 如果 total 数量不能触发下拉刷新条件显示没有更多了
            if (this.page.total <= (this.params.size * this.params.page) && this.page.total >= 1) {
              this.isEnd = true
            }
            if (this.page.pages < this.page.total) {
              this.params.page++
              // this.isEnd = true
            }
            this.groupActivityList = isAppend ? this.groupActivityList.concat(res.list) : res.list
          }
        })
        .catch(err => {
          this.loading = false
          console.log(err)
        })
    },

    // 分开展示tab栏数据
    showGroupNavList (first, last) {
      const showGroupNavList = this.groupNavList.slice(first, last)
      return showGroupNavList
    },

    handleTextFocus ($event) {
      this.showVisible = true
    },

    // 点击手动获取
    getMore ({ clear }) {
      this.getGroupActivity(this.params, true).then(() => {
        clear && clear()
      })
    }
  },

  watch: {
    // 判断是否滑动到底部，加载下一页数据
    isBottom (val) {
      val && !!this.loadingCount && this.loadingCount < 3 && this.getGroupActivity(this.params, true)
    }
  },

  // 销毁监听
  destroyed () {
    // 销毁监听点击事件
    window.removeEventListener('click', () => {}, true)
  }
}
</script>

<style lang="scss" scoped>
@import '../../../style/bulma/app.sass';

.background-wrapper {
  padding: 0 30px 0;
}

.group-tabs {
  display: flex;
  justify-content: space-between;
  height: 63px;
  padding-left: 20px;
  border-bottom: 1px solid #d9d9d9;
  // 点击不能复制
  -moz-user-select: none; /* Firefox私有属性 */
  -webkit-user-select: none; /* WebKit内核私有属性 */
  -ms-user-select: none; /* IE私有属性(IE10及以后) */
  -khtml-user-select: none; /* KHTML内核私有属性 */
  -o-user-select: none; /* Opera私有属性 */
  user-select: none; /* CSS3属性 */
}

.group-tab {
  max-width: 700px;
  padding: 20px 0 0 0;
  margin-right: 60px;
  cursor: pointer;
  text-align: center;
  // 超出部分隐藏
  overflow: hidden; //超出的文本隐藏
  text-overflow: ellipsis; //溢出用省略号显示
  white-space: nowrap; //溢出不换行
}

.group-tab-focus {
  padding-bottom: 13px;
  color: #D7B375;
  font-size: 18px;
  font-weight: 500;
}

.dropdown {
  display: flex;
  justify-content: flex-end;
  width: 120px;
}

.all-group-text {
  // padding-top: 16px;
  font-size: 14px; font-weight: 400;
  color: #353535;
  cursor: pointer;

  // 禁止选中文本
  -moz-user-select:none; /*火狐*/
  -webkit-user-select:none; /*webkit浏览器*/
  -ms-user-select:none; /*IE10*/
  -khtml-user-select:none; /*早期浏览器*/
  user-select:none;
}

.group-expand {
  position: relative;
  display: flex;
  justify-content: flex-end;
  align-items: baseline;
  min-width: 150px;
  padding: 22px 0 0 12px;
  color: #888888;
  overflow: hidden; //超出的文本隐藏
  text-overflow: ellipsis; //溢出用省略号显示
  white-space: nowrap; //溢出不换行
}

.group-expand-icon {
  margin-left: 6px;
}

.all-group-list {
  display: flex;
  align-items: center;
  padding: 15px 0;
  word-wrap: break-word;
  word-break: break-all;
}

.all-group-list-select {
  // position: absolute;
  // opacity: 0.3;
  width: 180px; height: 28px;
  background: url('https://static001.geekbang.org/resource/image/e6/fe/e67a916c3469555df06e4854a2deebfe.png') center / cover no-repeat;
}

.all-group-name-icon {
  display: inline-block;
  width: 3px; height: 16px;
  background: #D7B375;
}

.all-group-name {
  width: 150px;
  margin-left: 13px;
  overflow: hidden; //超出的文本隐藏
  text-overflow: ellipsis; //溢出用省略号显示
  white-space: nowrap; //溢出不换行
}

.all-group-name-select {
  color: #D1A75F;
}

::v-deep .Dropdown_dropdown-popup_3UXJ- {
  inset: 54px auto auto -54px !important;
}

.dropdown-options {
  width: 176px; height: 212px;
  overflow-y: auto;
  background: #FFFFFF;
  border: 1px solid #F1F1F1; border-radius: 5px;
  box-shadow: 0 -2px 15px rgba(228, 229, 231, 0.6);
}

.dropdown-option {
  display: flex;
  align-items: center;
  padding: 15px 10px 20px;
  // margin-bottom: 20px;
  line-height: 1;
  font-size: 14px; font-weight: 400;

  // &::v-deep span {
  //   font-weight: 500;
  //   color: #5C86FF;
  // }
}

.group-member-text {
  padding: 16px 0 13px;
  font-size: 18px; font-weight: 500;
  color: #353535;
}

.group-member-line {
  width: 802px; height: 2px;
  margin-left: -30px;
  background: #F7F5F6;
}

.group-activity-text {
  padding: 24px 0 15px;
  font-size: 18px; font-weight: 500;
  color: #353535;
}

.group-not-data {
  display: flex;
  justify-content: center;
}

.warnTip {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 100px 0;
}

.warnTip-center {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.warnTip-center-img {
  width: 100px
}

.warnTip-center-word {
  margin: 0 auto;
  margin-top: 10px;
  text-align: center;
}

::v-deep .event-info {
  border-left: 1px solid #E8E8E8;
  border-bottom: 1px solid #E8E8E8;
  border-right: 1px solid #E8E8E8;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

::v-deep .finish-label {
  color: #666666;
}

::v-deep .com-more-button {
  padding: 24px 0;
}

</style>
